var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime-corejs2/~/core-js/library/modules/_core.js
 ** module id = 78
 ** module chunks = 0
 **/